import { ICON_DEFAULT_COLOR, ICON_DEFAULT_SIZE } from '@constants/icons';
import { IconProps } from '@models/icons';

function PinFill({ size = ICON_DEFAULT_SIZE, color = ICON_DEFAULT_COLOR, ...rest }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...rest} >
            <path transform="translate(4 2.15)"
                d="M8 0C12.4183 4.46313e-08 15.9998 3.70483 16 8.27539C16 9.64069 15.5363 11.4119 14.9629 12.543C13.8051 14.8261 10.1162 18.1689 8.62988 19.4619C8.26632 19.7782 7.73368 19.7782 7.37012 19.4619C5.88379 18.1689 2.1949 14.8261 1.03711 12.543C0.463746 11.4119 0 9.64069 0 8.27539C0.000245795 3.70483 3.58174 0 8 0ZM8 4.24902C6.34315 4.24902 5 5.59217 5 7.24902C5.00011 8.90578 6.34322 10.249 8 10.249C9.65678 10.249 10.9999 8.90578 11 7.24902C11 5.59217 9.65685 4.24902 8 4.24902Z"
                fill={color}/>
        </svg>
    );
}

export default PinFill;
